import { useEffect } from 'react';

const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';

const websiteSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: '김영엔지니어링',
  url: siteUrl,
  inLanguage: 'ko',
  publisher: {
    '@type': 'Organization',
    name: '김영엔지니어링',
    url: siteUrl,
  },
  potentialAction: {
    '@type': 'SearchAction',
    target: {
      '@type': 'EntryPoint',
      urlTemplate: `${siteUrl}/?s={search_term_string}`,
    },
    'query-input': 'required name=search_term_string',
  },
};

const organizationSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: '김영엔지니어링',
  url: siteUrl,
  logo: {
    '@type': 'ImageObject',
    url: 'https://static.readdy.ai/image/b501bf94bb59408c2ba1e19180046ac8/1fb21cb20452d08dacba0f658c1052b4.jpeg',
  },
  image: 'https://static.readdy.ai/image/b501bf94bb59408c2ba1e19180046ac8/1fb21cb20452d08dacba0f658c1052b4.jpeg',
  description:
    '화재 시뮬레이션, 피난 시뮬레이션, 군중 흐름 분석 전문 기업. PyroSim, Pathfinder, Ventus 소프트웨어 공급 및 컨설팅.',
  address: {
    '@type': 'PostalAddress',
    streetAddress: '시흥대로 281, 505호',
    addressLocality: '금천구',
    addressRegion: '서울특별시',
    postalCode: '08609',
    addressCountry: 'KR',
  },
  contactPoint: {
    '@type': 'ContactPoint',
    telephone: '+82-2-807-7750',
    contactType: '고객 서비스',
    email: 'kimyoung@epcmart.co.kr',
    availableLanguage: ['Korean', 'English'],
  },
  openingHoursSpecification: [
    {
      '@type': 'OpeningHoursSpecification',
      dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'],
      opens: '09:00',
      closes: '18:00',
    },
  ],
  sameAs: ['https://www.youtube.com/@pyrosim1'],
};

const localBusinessSchema = {
  '@context': 'https://schema.org',
  '@type': 'LocalBusiness',
  name: '김영엔지니어링',
  url: siteUrl,
  telephone: '+82-2-807-7750',
  email: 'kimyoung@epcmart.co.kr',
  image: 'https://static.readdy.ai/image/b501bf94bb59408c2ba1e19180046ac8/1fb21cb20452d08dacba0f658c1052b4.jpeg',
  description:
    '서울 금천구에 위치한 화재 시뮬레이션, 피난 시뮬레이션, 군중 흐름 분석 전문 기업. PyroSim, Pathfinder, Ventus 소프트웨어 공급 및 컨설팅.',
  address: {
    '@type': 'PostalAddress',
    streetAddress: '시흥대로 281, 505호',
    addressLocality: '금천구',
    addressRegion: '서울특별시',
    postalCode: '08609',
    addressCountry: 'KR',
  },
  geo: {
    '@type': 'GeoCoordinates',
    latitude: 37.4563,
    longitude: 126.8956,
  },
  openingHoursSpecification: [
    {
      '@type': 'OpeningHoursSpecification',
      dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'],
      opens: '09:00',
      closes: '18:00',
    },
  ],
  priceRange: '$$',
  currenciesAccepted: 'KRW',
  paymentAccepted: '현금, 계좌이체',
};

const webPageSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  '@id': `${siteUrl}/#webpage`,
  name: '김영엔지니어링',
  url: siteUrl,
  description:
    '김영엔지니어링은 서울 금천구에 위치한 화재 시뮬레이션, 피난 시뮬레이션, 군중 흐름 분석 전문 기업입니다. PyroSim, Pathfinder, Ventus 소프트웨어 공급 및 컨설팅, 300건 이상의 프로젝트 경험 보유.',
  inLanguage: 'ko',
  dateModified: '2026-03-23',
  isPartOf: {
    '@type': 'WebSite',
    name: '김영엔지니어링',
    url: siteUrl,
  },
  publisher: {
    '@type': 'Organization',
    name: '김영엔지니어링',
    url: siteUrl,
  },
  breadcrumb: {
    '@type': 'BreadcrumbList',
    itemListElement: [
      {
        '@type': 'ListItem',
        position: 1,
        name: '홈',
        item: siteUrl,
      },
    ],
  },
};

const serviceSchema = {
  '@context': 'https://schema.org',
  '@type': 'Service',
  serviceType: '화재 시뮬레이션 및 피난 시뮬레이션 컨설팅',
  provider: {
    '@type': 'Organization',
    name: '김영엔지니어링',
    url: siteUrl,
  },
  areaServed: {
    '@type': 'Country',
    name: '대한민국',
  },
  hasOfferCatalog: {
    '@type': 'OfferCatalog',
    name: '시뮬레이션 서비스',
    itemListElement: [
      {
        '@type': 'Offer',
        itemOffered: {
          '@type': 'Service',
          name: '화재 시뮬레이션',
          description:
            '연기 확산, 가시거리, 구조물 온도를 사실적으로 계산하고 영화 수준의 3D 모델로 시각화하여 종합적인 화재 안전 분석을 제공합니다.',
        },
      },
      {
        '@type': 'Offer',
        itemOffered: {
          '@type': 'Service',
          name: '피난 시뮬레이션',
          description:
            '3D로 인간 행동을 모델링하고 혼잡도 및 피난 시간을 계산합니다. 비상 상황 및 일상적인 상황에서의 군중 흐름을 분석합니다.',
        },
      },
      {
        '@type': 'Offer',
        itemOffered: {
          '@type': 'Service',
          name: '컨설팅 & 교육',
          description:
            '소프트웨어 교육 및 시뮬레이션 서비스 파트너십을 위한 전문가 지도와 지원.',
        },
      },
    ],
  },
};

const softwareListSchema = {
  '@context': 'https://schema.org',
  '@type': 'ItemList',
  name: '화재·피난·폭발 시뮬레이션 소프트웨어 솔루션',
  description: '김영엔지니어링이 공급하는 첨단 시뮬레이션 소프트웨어 목록',
  itemListElement: [
    {
      '@type': 'ListItem',
      position: 1,
      item: {
        '@type': 'SoftwareApplication',
        name: 'PyroSim',
        applicationCategory: '화재 시뮬레이션 소프트웨어',
        description:
          '화재 시뮬레이션을 간편하게. CAD 데이터에서 FDS 모델을 그래픽으로 생성·평가하거나, 몇 번의 클릭만으로 BIM 데이터셋을 모델로 변환하세요.',
        url: 'https://www.thunderheadeng.com/pyrosim/features/',
        operatingSystem: 'Windows',
        offers: { '@type': 'Offer', seller: { '@type': 'Organization', name: '김영엔지니어링' } },
      },
    },
    {
      '@type': 'ListItem',
      position: 2,
      item: {
        '@type': 'SoftwareApplication',
        name: 'Pathfinder',
        applicationCategory: '피난 시뮬레이션 소프트웨어',
        description:
          '피난을 사실적으로 시뮬레이션하고, 화재 시뮬레이션 결과를 원활하게 통합하며, 고급 모델링으로 일상적인 군중 흐름을 최적화합니다.',
        operatingSystem: 'Windows',
        offers: { '@type': 'Offer', seller: { '@type': 'Organization', name: '김영엔지니어링' } },
      },
    },
    {
      '@type': 'ListItem',
      position: 3,
      item: {
        '@type': 'SoftwareApplication',
        name: 'Ventus',
        applicationCategory: '제연 시뮬레이션 소프트웨어',
        description:
          'CAD 데이터로 CONTAM 소프트웨어용 시뮬레이션 모델을 생성합니다. 제연 가압 시스템 및 환기 분석을 위한 건물 압력 조건을 시뮬레이션합니다.',
        operatingSystem: 'Windows',
        offers: { '@type': 'Offer', seller: { '@type': 'Organization', name: '김영엔지니어링' } },
      },
    },
    {
      '@type': 'ListItem',
      position: 4,
      item: {
        '@type': 'SoftwareApplication',
        name: 'ExDAM',
        applicationCategory: '폭발 피해 평가 소프트웨어',
        description:
          '폭발 피해 평가 모델 - 부상 및 구조적 피해를 예측하는 3D 폭발 결과 모델링 도구.',
        url: 'https://shop.trinityconsultants.com/software',
        operatingSystem: 'Windows',
        offers: { '@type': 'Offer', seller: { '@type': 'Organization', name: '김영엔지니어링' } },
      },
    },
    {
      '@type': 'ListItem',
      position: 5,
      item: {
        '@type': 'SoftwareApplication',
        name: 'PIPENET',
        applicationCategory: '배관 흐름 해석 소프트웨어',
        description: '배관 및 덕트 내 유체 흐름을 신속하게 설계하고 분석하는 소프트웨어.',
        url: 'https://sunrise-sys.com/pipenet/',
        operatingSystem: 'Windows',
        offers: { '@type': 'Offer', seller: { '@type': 'Organization', name: '김영엔지니어링' } },
      },
    },
    {
      '@type': 'ListItem',
      position: 6,
      item: {
        '@type': 'SoftwareApplication',
        name: 'BEASY',
        applicationCategory: '부식 감지 소프트웨어',
        description: '업계 최고의 부식 감지 및 방지 솔루션을 제공합니다.',
        url: 'https://www.beasy.com/software',
        operatingSystem: 'Windows',
        offers: { '@type': 'Offer', seller: { '@type': 'Organization', name: '김영엔지니어링' } },
      },
    },
  ],
};

const faqSchema = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: [
    {
      '@type': 'Question',
      name: '화재 시뮬레이션이란 무엇인가요?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '화재 시뮬레이션은 연기 확산, 가시거리, 구조물 온도를 사실적으로 계산하고 영화 수준의 3D 모델로 시각화하여 종합적인 화재 안전 분석을 제공하는 기술입니다.',
      },
    },
    {
      '@type': 'Question',
      name: '피난 시뮬레이션은 언제 필요한가요?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '피난 시뮬레이션은 건물 설계 단계에서 비상 상황의 군중 흐름과 피난 시간을 사전에 분석하여 안전한 피난 경로를 확보하기 위해 필요합니다.',
      },
    },
    {
      '@type': 'Question',
      name: 'PyroSim과 Pathfinder 소프트웨어를 구매할 수 있나요?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '네, 김영엔지니어링은 PyroSim, Pathfinder, Ventus 등 첨단 시뮬레이션 소프트웨어의 독점 파트너로서 한국어 버전, 기술 지원 및 맞춤형 교육 프로그램을 제공합니다.',
      },
    },
    {
      '@type': 'Question',
      name: '폭발 시뮬레이션도 가능한가요?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '네, 김영엔지니어링은 ExDAM 소프트웨어를 통해 3D 폭발 결과 모델링 및 구조적 피해 평가 서비스를 제공합니다.',
      },
    },
    {
      '@type': 'Question',
      name: '김영엔지니어링은 어디에 위치해 있나요?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '서울특별시 금천구 시흥대로 281, 505호에 위치해 있습니다. 전화(02-807-7750) 또는 이메일(kimyoung@epcmart.co.kr)로 연락하실 수 있습니다.',
      },
    },
  ],
};

export default function SeoJsonLd() {
  useEffect(() => {
    const schemas = [
      websiteSchema,
      organizationSchema,
      localBusinessSchema,
      webPageSchema,
      serviceSchema,
      softwareListSchema,
      faqSchema,
    ];

    const scriptTags: HTMLScriptElement[] = [];

    schemas.forEach((schema, index) => {
      const existingScript = document.getElementById(`schema-jsonld-${index}`);
      if (existingScript) {
        existingScript.remove();
      }
      const script = document.createElement('script');
      script.type = 'application/ld+json';
      script.id = `schema-jsonld-${index}`;
      script.textContent = JSON.stringify(schema);
      document.head.appendChild(script);
      scriptTags.push(script);
    });

    return () => {
      scriptTags.forEach((script) => {
        if (document.head.contains(script)) {
          document.head.removeChild(script);
        }
      });
    };
  }, []);

  return null;
}
